import { mapGetters, mapActions } from 'vuex'
import { clientService } from '@/services/client-service'
import { userClientConfigurationService } from '@/services/user-client-configuration-service'
import router from '../../router'

export default {
  data() {
    return {
      clients: [],
      client: null
    }
  },
  computed: {
    ...mapGetters(['userClient', 'userId']),
    companyOptions() {
      return this.clients.map((c) => ({ label: c.name, value: c.code }))
    }
  },
  watch: {
    '$store.getters.updateClient': function () {
      if (this.$store.getters.updateClient) {
        this.fetchClientes()
        this.$store.commit('user/SET_UPDATECLIENT', false)
      }
    }
  },
  created() {
    this.fetchClientes()
    this.client = this.userClient
    this.getApprovalsByClient()
  },
  methods: {
    ...mapActions('approval', ['loadApproval']),
    ...mapActions('user', ['setUserClient']),
    async fetchClientes() {
      const { data } = await clientService.getByUserToken()
      this.clients = data
    },
    selectCompany(code) {
      if (code === this.client) return
      this.client = code
      this.changeClient()
    },
    async changeClient() {
      this.setUserClient(this.client)
      await this.changeUserHierarchy()
      await this.getApprovalsByClient()
      await this.$store.dispatch('user/updateEcosystems')
      await this.$store.dispatch('user/updateIsCycleManager')
      if (this.$route.path !== '/home/index') {
        router.push('/home')
      }
    },

    async getApprovalsByClient() {
      await this.loadApproval()
    },

    async changeUserHierarchy() {
      const { data } = await userClientConfigurationService.getByUserAndClient(
        this.userId,
        this.userClient
      )
      this.$store.state.user.userHierarchy = data ? data.units : []
      this.$store.state.user.userUnit = data ? data.units : []
    }
  }
}
